import { Stack, useRouter } from 'expo-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { HomeTileTypeIds } from 'shared/hooks/homeTiles/HomeTileTypeIds';
import useRefreshHomeTiles from 'shared/hooks/homeTiles/useRefreshHomeTiles';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

const PaymentSuccess = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'makePayment',
  });

  const backToAccountDetails = () => {
    if (router.canGoBack()) {
      router.dismissAll();
    }
    router.back();
  };

  const { refreshTiles } = useRefreshHomeTiles([
    HomeTileTypeIds.INTERNAL_ACCOUNT_TILE_CHECKING,
    HomeTileTypeIds.INTERNAL_ACCOUNT_TILE_SAVINGS,
    HomeTileTypeIds.INTERNAL_ACCOUNT_TILE_CHARGE_CARD,
    HomeTileTypeIds.LINKED_ACCOUNTS_TILE,
  ]);

  useEffect(() => {
    refreshTiles();
  }, [refreshTiles]);

  useBackHandler(backToAccountDetails);

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerBackVisible: false,
          headerShown: false,
          gestureEnabled: false,
        }}
      />
      <SuccessScreen
        primaryButton={{
          label: translatedText('buttons.doneButton'),
          onPress: () => {
            backToAccountDetails();
          },
          analyticsId: 'believePaymentSuccess',
        }}
        eyebrowText={translatedText('success.niceJob')}
        visual="CASH_A_ANIMATED"
        titleText={translatedText('success.madePayment')}
        content={
          <BodyBaseText style={styles.contentText}>
            {translatedText('success.madePaymentInfo')}
          </BodyBaseText>
        }
        screenAnalyticsEventKey="paymentSuccessScreen"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  contentText: {
    textAlign: 'center',
  },
});

export default PaymentSuccess;
